import React from 'react'
import { ReactNode } from 'react'
import { OptionProps } from './Option'

export const nodeContainsText = (
  node: ReactNode,
  text: string,
  comparisonMethod: 'includes' | 'startsWith' = 'includes'
): boolean => {
  if (!node || typeof node === 'boolean') {
    return false
  }
  if (typeof node === 'string' || typeof node === 'number') {
    const nodeText = String(node).toLocaleLowerCase().trim()
    return nodeText[comparisonMethod](text.toLocaleLowerCase())
  }
  const childrenArray = React.Children.toArray(node)
  return childrenArray.some(
    child =>
      React.isValidElement(child) && nodeContainsText(child.props.children, text, comparisonMethod)
  )
}

export const isSelectableOption: <ValueType = string>(
  optionProps: OptionProps<ValueType>
) => boolean = ({ isCategoryControl, isCategoryLabel }) => !(isCategoryControl || isCategoryLabel)

export const allOptionsContainerStyles = {
  display: 'flex',
  h: 9,
  m: 0,
  px: 5,
  py: 0,
  mb: -2,
  alignItems: 'center',
  w: '100%',
} as const
